import React from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Carousel } from "react-responsive-carousel";
import CountUp from "react-countup";

import { MinMilestones } from "../ui";

const CarouselMin = (props) => {
  const { raised, teamRaised, streamType } = props.overlayStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const textColor = urlParams.get("textColor");

  return (
    <div>
      <Carousel
        axis="vertical"
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        showArrows={false}
        infiniteLoop
        autoPlay
        interval={10000}
        // onChange={() => selectedItem === 2 ? 'this is 2' : 'this is not 2'}
      >
        <div>
          <div className="logo">
            <div className="sj_logo">
              <span>SJ Logo</span>
            </div>
          </div>
          <p className={`therm-raised ${textColor}`}>
            {streamType === "@" ? (
              <CountUp
                end={raised}
                duration={1}
                separator=","
                decimals={raised - Math.floor(raised) !== 0 ? 2 : 0}
                prefix="$"
                preserveValue={true}
                useEasing={false}
              />
            ) : streamType === "+" ? (
              <CountUp
                end={teamRaised}
                duration={1}
                separator=","
                decimals={2}
                prefix="$"
                preserveValue={true}
                useEasing={false}
              />
            ) : (
              ""
            )}
          </p>
        </div>
        <div>
          <MinMilestones />
        </div>
        <div>
          <div className="logo">
            <div className="playlive_logo">
              <span>Play Live Logo</span>
            </div>
          </div>
          <p className={`therm-raised ${textColor}`}>
            {streamType === "@" ? (
              <CountUp
                end={raised}
                duration={1}
                separator=","
                decimals={2}
                prefix="$"
                preserveValue={true}
                useEasing={false}
              />
            ) : streamType === "+" ? (
              <CountUp
                end={teamRaised}
                duration={1}
                separator=","
                decimals={2}
                prefix="$"
                preserveValue={true}
                useEasing={false}
              />
            ) : (
              ""
            )}
          </p>
        </div>
        <div>
          <MinMilestones />
        </div>
      </Carousel>
    </div>
  );
};

export default inject("overlayStore")(observer(CarouselMin));
